import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class SubscriptionsService extends EntityService {
  static get entity() {
    return 'subscriptions';
  }

  static async getBillingPeriods() {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/billing-periods`
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
}
